import { render } from "./EditingMediaTvSimple.vue?vue&type=template&id=f270593e"
import script from "./EditingMediaTvSimple.vue?vue&type=script&lang=js"
export * from "./EditingMediaTvSimple.vue?vue&type=script&lang=js"
script.render = render

export default script